<template>
  <d-list-group flush>
    <d-list-group-item class="p-3">
      <d-form @submit.prevent="save">
        <d-form-row>
          <!-- Nome -->
          <d-col md="8" class="form-group">
            <label for="label">Nome do template</label>
            <d-form-input
              :state="hasErrorFiled('name')"
              type="text"
              placeholder="Nome"
              v-model="model.name"
            />
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>
        </d-form-row>

        <table class="table w-full">
          <thead>
            <tr>
              <th>#</th>
              <th>Tipo</th>
              <th>Produto</th>
              <th class="text-right">Opções</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in model.rows" :key="index">
              <td>{{ index+1 }}</td>
              <td>
                <d-select v-model="row.type_id" >
                  <option :value="option.id" v-for="option in productTypeOptions" :key="option.id">{{ option.name }}</option>
                </d-select>
              </td>
              <td>
                <autocomplete
                  :ref="`Product_${index}`"
                  placeholder="Produto"
                  :items="products"
                  item-show="name"
                  :parameter="row"
                  :on-input="onInputProduct"
                  :on-select="setProduct"
                ></autocomplete>
              </td>
              <td class="text-right">
                <i class="fas fa-plus text-success" @click="addRow()" v-if="index + 1 == model.rows.length"></i>
                <i class="fas fa-minus text-danger ml-2" @click="removeRow(index)"></i>
              </td>
            </tr>
          </tbody>
        </table>

        <d-form-row>

          <!-- Comentários -->
          <d-col md="6" lg="6" cols="12" class="form-group">
            <label for="feComentarios" class="d-flex justify-content-between">
              Obrigações contratante
              <button v-if="!model.obligations_buyer" @click="openObligation('contractor')" type="button" class="btn-primary btn-sm py-1 btn-sm">Obrigações Contratante</button>
            </label>
            <editor :model.sync="model.obligations_buyer" />
          </d-col>

          <!-- Obrigações -->
          <d-col md="6" lg="6" cols="12" class="form-group">
            <label for="feObligations" class="d-flex justify-content-between">
              Obrigações contratado
              <button v-if="!model.obligations_seller" @click="openObligation('hired')" type="button" class="btn-primary btn-sm py-1 btn-sm">Obrigações Contratado</button>
            </label>
            <editor :model.sync="model.obligations_seller"/>
          </d-col>

        </d-form-row>

        <d-button type="submit" class="btn-accent float-right mr-2">Salvar</d-button>

        <contractual-items-select-modal/>
      </d-form>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { cloneDeep, stringfy } from '_utils';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import ContractualItemsSelectModal from '_modules/quotation/components/modal/ContractualItemsSelectModal.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import QuotationService from '_services/rest/modules/quotation';
import {
  TEMPLATE_ROW,
  TEMPLATE_MODEL,
  _OPEN_CONFIRMATION_,
  _LOAD_TEMPLATE_MODEL_,
  _OPEN_OBLIGATION_MODAL_,
  _SET_OBLIGATION_IN_QUOTATION_,
} from './QuotationModel';

export default {
  name: 'group-form',
  mixins: [MixinValidateForm],
  components: {
    Editor,
    Autocomplete,
    ContractualItemsSelectModal,
  },
  props: {
    template: {
      type: Object,
      default: () => { cloneDeep(TEMPLATE_MODEL); },
    },
  },
  data() {
    return {
      errors: {
        name: { required: false },
      },
    };
  },
  computed: {
    model: {
      get() {
        return this.template;
      },
      set(value) {
        this.$emit('update:template', value);
      },
    },
    products() {
      const { productVariationsList } = this.$store.state.product;
      if (productVariationsList && productVariationsList.list.length) {
        return productVariationsList.list;
      }
      return [];
    },
    ...mapState({
      productTypeOptions: state => state.quotation.productTypeOptions,
    }),
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getHireds',
      'activeAlert',
      'getContractors',
      'getProductVariations',
      'getProductTypeOptions',
    ]),
    openObligation(type) {
      this.setToggle({ type: 'add_obligations_modal', bool: true });
      Events.$emit(_OPEN_OBLIGATION_MODAL_, { type });
    },
    addRow() {
      this.$nextTick(() => {
        this.model.rows.push({ ...TEMPLATE_ROW });
      });
    },
    confirmDeleteTab(index) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_OPEN_CONFIRMATION_, { quotation: index, type: 'deleteTab' });
    },
    getOptions() {
      if (!this.$store.state.quotation.productTypeOptions) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductTypeOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.settings.hired) {
        this.getHireds();
      }
      if (!this.$store.state.settings.contractor) {
        this.getContractors();
      }
    },
    removeRow(index) {
      this.model.rows.splice(index, 1);
      setTimeout(() => {
        this.setProductInAutocomplete();
      }, 50);
    },
    onInputProduct(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getProductVariations({ search: name });
      }, 500);
    },
    setProduct(product, item) {
      item.variation = product;
      item.variation_id = product.id;
    },
    setProductInAutocomplete() {
      this.model.rows.map((product, navItemId) => {
        if (this.$refs[`Product_${navItemId}`][0] && product.variation.name) {
          this.$refs[`Product_${navItemId}`][0].$refs.input.value = product.variation.name;
        }
        return product;
      });
    },
    save() {
      this.model.slug = stringfy(this.model.name);
      QuotationService.saveTemplate(this.model)
        .then(response => {
          this.activeAlert({ message: 'Template salvo com sucesso', theme: 'success' });
          if (!this.$route.params.templateId) {
            this.$router.push({ name: 'admin-quotation-template-edit', params: { templateId: response.id } });
          }
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    this.getOptions();
    Events.$on(_LOAD_TEMPLATE_MODEL_, () => {
      this.$nextTick(() => {
        this.setProductInAutocomplete();
      });
    });
    Events.$on(_SET_OBLIGATION_IN_QUOTATION_, ({ obligation, type }) => {
      const field = { contractor: 'obligations_buyer', hired: 'obligations_seller' };
      this.model[field[type]] = obligation;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.table {
  border: 1px solid #dee2e6;
  tr th {
    border-bottom: 0;
  }
  td {
    vertical-align: middle;
  }
}
</style>
